import * as req from 'api/actions';
import * as c from './constant';

// eslint-disable-next-line import/prefer-default-export
export const getList = (payload, callback) =>
  req.list(
    c.LIST,
    '/api/v1/bpls/administrator/transaction_histories/permits',
    payload,
    callback
  );

export const getItem = (id, payload, callback) =>
  req.item(
    c.ITEM,
    `/api/v1/bpls/administrator/transaction_histories/permits/${id}`,
    payload,
    callback
  );

export const toggleAssessment = (id, payload, callback) =>
  req.create(
    c.TOGGLE_ASSESSMENT,
    `/api/v1/bpls/administrator/transaction_histories/permits/${id}/toggle_assessment`,
    payload,
    callback
  );

export const generateBIN = (id, payload, callback) =>
  req.create(
    c.GENERATE_BIN,
    `/api/v1/bpls/administrator/transaction_histories/permits/${id}/generate_bin`,
    payload,
    callback
  );

export const initialComputation = (id, payload, callback) =>
  req.create(
    c.INITIAL_COMPUTATION,
    `/api/v1/bpls/administrator/transaction_histories/permits/${id}/initial_calculate`,
    payload,
    callback
  );

export const getCalculation = (permitId, feeId, payload, callback) =>
  req.list(
    c.CALCULATION,
    `/api/v1/bpls/administrator/transaction_histories/permits/${permitId}/initial_fees/${feeId}/calculations`,
    payload,
    callback
  );

export const updateCalculation = (
  permitId,
  initialFeeId,
  calculationId,
  payload,
  callback
) =>
  req.update(
    c.INITIAL_COMPUTATION,
    `/api/v1/bpls/administrator/transaction_histories/permits/${permitId}/initial_fees/${initialFeeId}/calculations/${calculationId}`,
    payload,
    callback
  );

export const clearItem = (constant, value) => req.setItem(constant, value);
export const clearList = (constant, value) => req.setList(constant, value);

export const finalComputation = (id, payload, callback) =>
  req.create(
    c.FINAL_COMPUTATION,
    `/api/v1/bpls/administrator/transaction_histories/permits/${id}/final_calculate`,
    payload,
    callback
  );

export const approve = (permitId, payload, callback) =>
  req.create(
    c.APPROVE,
    `/api/v1/bpls/administrator/transaction_histories/permits/${permitId}/approve`,
    payload,
    callback
  );

export const reject = (permitId, payload, callback) =>
  req.create(
    c.REJECT,
    `/api/v1/bpls/administrator/transaction_histories/permits/${permitId}/reject`,
    payload,
    callback
  );

export const release = (permitId, payload, callback) =>
  req.create(
    c.REJECT,
    `/api/v1/bpls/administrator/transaction_histories/permits/${permitId}/receive`,
    payload,
    callback
  );

export const approveOwnership = (permitId, payload, callback) =>
  req.create(
    c.APPROVE_OWNERSHIP,
    `/api/v1/bpls/administrator/transaction_histories/permits/${permitId}/approve_ownership`,
    payload,
    callback
  );

export const updateApplication = (id, payload, callback) =>
  req.create(
    c.UPDATE_APPLICATION,
    `/api/v1/bpls/administrator/transaction_histories/permits/${id}/assess_new_application`,
    payload,
    callback
  );

export const getBusinessActivityList = (id, payload, callback) =>
  req.list(
    c.GET_BUSINESS_ACTIVITY_LIST,
    `/api/v1/bpls/administrator/transaction_histories/permits/${id}/business_activities`,
    payload,
    callback
  );

export const getBusinessNaturesList = (payload, callback) =>
  req.list(
    c.GET_BUSINESS_NATURES_LIST,
    `api/v1/bpls/administrator/common/business_natures`,
    payload,
    callback
  );

export const getBusinessLinesList = (payload, callback) =>
  req.list(
    c.GET_BUSINESS_LINES_LIST,
    `api/v1/bpls/administrator/common/business_lines`,
    payload,
    callback
  );

export const getNecessaryFieldsList = (payload, callback) =>
  req.list(
    c.GET_NECESSARY_FIELD_LIST,
    `api/v1/bpls/administrator/common/neccessary_fields`,
    payload,
    callback
  );

export const createBusinessActivity = (id, payload, callback) =>
  req.create(
    c.CREATE_BUSINESS_ACTIVITY,
    `api/v1/bpls/administrator/transaction_histories/permits/${id}/business_activities`,
    payload,
    callback
  );

export const updateBusinessActivity = (
  id,
  businessActivityId,
  payload,
  callback
) =>
  req.update(
    c.UPDATE_BUSINESS_ACTIVITY,
    `api/v1/bpls/administrator/transaction_histories/permits/${id}/business_activities/${businessActivityId}`,
    payload,
    callback
  );

export const removeBusinessActivity = (
  id,
  businessActivityId,
  payload,
  callback
) =>
  req.remove(
    c.REMOVE_BUSINESS_ACTIVITY,
    `api/v1/bpls/administrator/transaction_histories/permits/${id}/business_activities/${businessActivityId}`,
    payload,
    callback
  );

export const generateTransmittal = (payload, callback) =>
  req.create(
    c.GENERATE_TRANSMITTAL,
    `api/v1/bpls/administrator/transaction_histories/transmittal/generate`,
    payload,
    callback
  );

export const forwardToLicense = (permitId, payload, callback) =>
  req.create(
    c.FORWARD_TO_LICENSE,
    `/api/v1/bpls/administrator/transaction_histories/permits/${permitId}/forward_to_license`,
    payload,
    callback
  );

export const toggleLicenseAssessment = (id, payload, callback) =>
  req.create(
    c.TOGGLE_LICENSE_ASSESSMENT,
    `/api/v1/bpls/administrator/transaction_histories/permits/${id}/toggle_assessment`,
    payload,
    callback
  );

export const generateSOA = (id, payload, callback) =>
  req.create(
    c.GENERATE_SOA,
    `/api/v1/bpls/administrator/transaction_histories/permits/${id}/generate_soa`,
    payload,
    callback
  );
export const generateSOARetirement = (id, payload, callback) =>
  req.create(
    c.GENERATE_SOA,
    `/api/v1/bpls/administrator/transaction_histories/permits/${id}/retirement/generate_soa`,
    payload,
    callback
  );

export const addBusinessRemarks = (id, payload, callback) =>
  req.create(
    c.ADD_BUSINESS_REMARKS,
    `/api/v1/bpls/administrator/transaction_histories/permits/${id}/update_remarks`,
    payload,
    callback
  );

// address
export const getRegionsList = (payload, callback) =>
  req.list(
    c.GET_REGION,
    'api/v1/administrators/address/regions',
    payload,
    callback
  );

export const getProvinceList = (payload, callback) =>
  req.list(
    c.GET_PROVINCE,
    'api/v1/administrators/address/provinces',
    payload,
    callback
  );

export const getMunicipalityList = (payload, callback) =>
  req.list(
    c.GET_MUNICIPALITIES,
    'api/v1/administrators/address/municipalities',
    payload,
    callback
  );

export const getBarangayList = (payload, callback) =>
  req.list(
    c.GET_BARANGAYS,
    'api/v1/administrators/address/barangays',
    payload,
    callback
  );

export const getVetRegistrationList = (payload, callback) =>
  req.list(
    c.GET_VET_REGISTRATION_LIST,
    '/api/v1/bpls/administrator/common/veterinary_registrations',
    payload,
    callback
  );

export const updateCedulaAmount = (id, payload, callback) =>
  req.create(
    c.UPDATE_CEDULA_AMOUNT,
    `/api/v1/bpls/administrator/transaction_histories/permits/${id}/update_fee`,
    payload,
    callback,
    (res) => {
      const { message } = res.res;
      alert.success(message || 'Successfully Updated !');
      if (callback) callback();
    }
  );

export const updateBusinessActivityGrossAmount = (
  id,
  businessActivityId,
  payload,
  callback
) =>
  req.update(
    c.UPDATE_BUSINESS_ACTIVITY_GROSS_AMOUNT,
    `/api/v1/bpls/administrator/transaction_histories/permits/${id}/update_activity_amount/${businessActivityId}`,
    payload,
    callback
  );

export const getLogs = (id, payload, callback) =>
  req.list(
    c.GET_LOGS,
    `/api/v1/bpls/administrator/transaction_histories/permits/${id}/logs`,
    payload,
    callback
  );

export const changeApplication = (id, payload, callback) =>
  req.create(
    c.CHANGE_APPLICATION,
    `/api/v1/bpls/administrator/transaction_histories/permits/${id}/assessed_change_request`,
    payload,
    callback
  );

export const updateDelinquentCalculation = (id, payload, callback) =>
  req.create(
    c.UPDATE_DELINQUENT_CALCULATION_DETAIL,
    `/api/v1/bpls/administrator/transaction_histories/permits/${id}/update_delinquent_calculation_details`,
    payload,
    callback
  );

export const getCodeList = (payload, callback) =>
  req.list(
    c.GET_CODE_LIST,
    `api/v1/bpls/administrator/common/fee_codes`,
    payload,
    ({ res }) => {
      const { data } = res;
      if (callback) callback({ data });
    }
  );

export const addDelinquentYear = (id, payload, callback) =>
  req.create(
    c.ADD_DELINQUENT_YEAR,
    `/api/v1/bpls/administrator/transaction_histories/permits/${id}/create_fee`,
    payload,
    callback
  );

export const updateFees = (permitId, initialFeeId, payload, callback) =>
  req.update(
    c.UPDATE_FEES,
    `/api/v1/bpls/administrator/transaction_histories/permits/${permitId}/billing_fees/${initialFeeId}`,
    payload,
    callback
  );

export const getCitizenshipList = (payload, callback) =>
  req.list(
    c.GET_CITIZENSHIP,
    'api/v1/administrators/citizenship',
    payload,
    callback
  );

export const cancelSoa = (permitId, payload, callback) =>
  req.create(
    c.CANCEL_SOA,
    `/api/v1/bpls/administrator/transaction_histories/permits/${permitId}/cancel_soa`,
    payload,
    callback
  );

export const retirementApplication = (id, callback) =>
  req.create(
    c.RETIREMENT_APPLICATION,
    `/api/v1/bpls/administrator/transaction_histories/permits/${id}/assessed_retirement`,
    callback
  );
export const assessRetirementRequest = (id, payload, callback) =>
  req.create(
    c.ASSESS_RETIREMENT_REQUEST,
    `/api/v1/bpls/administrator/transaction_histories/permits/${id}/assessed_retirement_request`,
    payload,
    callback
  );

export const cancelApplication = (permitId, payload, callback) =>
  req.create(
    c.CANCEL_APPLICATION,
    `/api/v1/bpls/administrator/transaction_histories/permits/${permitId}/cancel_application`,
    payload,
    callback
  );

export const assessRenewApplication = (permitId, payload, callback) =>
  req.create(
    c.ASSESS_RENEW_APPLICATION,
    `/api/v1/bpls/administrator/transaction_histories/permits/${permitId}/assess_renewal_application`,
    payload,
    callback
  );

export const validateBusinessActivity = (
  id,
  businessActivityId,
  payload,
  callback
) =>
  req.update(
    c.VALIDATE_BUSINESS_ACTIVITY,
    `api/v1/bpls/administrator/transaction_histories/permits/${id}/business_activities/${businessActivityId}/validate_activity`,
    payload,
    callback
  );

// notification count
export const getTransactionCount = (
  payload = { module_type: 'BPLS' },
  callback
) =>
  req.list(
    c.GET_TRANSACTION_COUNTS,
    '/api/v1/bpls/administrator/transaction_histories/permits',
    payload,
    callback
  );

export const onRevoke = (id, payload, callback) =>
  req.create(
    c.REVOKE_PERMIT,
    `/api/v1/bpls/administrator/transaction_histories/permits/${id}/toggle_revoke_permit`,
    payload,
    callback
  );

export const returnToPermit = (id, payload, callback) =>
  req.create(
    c.RETURN_TO_PERMIT,
    `/api/v1/bpls/administrator/transaction_histories/permits/${id}/return_to_permit`,
    payload,
    callback
  );

export const recalculateSOA = (id, payload, callback) =>
  req.create(
    c.RECALCULATE_SOA,
    `/api/v1/bpls/administrator/transaction_histories/permits/${id}/regenerate_soa`,
    payload,
    callback
  );

export const getTransmittalList = (payload, callback) =>
  req.list(
    c.GET_TRANSMITTAL_LIST,
    '/api/v1/bpls/administrator/transaction_histories/transmittals',
    payload,
    callback
  );

export const inquirePreviousOR = (id, callback) =>
  req.item(
    c.INQUIRE_PREVIOUS_OR,
    `/api/v1/bpls/administrator/transaction_histories/permits/${id}/inquire_previous_or`,
    ({ res }) => {
      const { data } = res;
      if (callback) callback({ data });
    }
  );

export const uploadCTC = (id, payload, callback) =>
  req.create(
    c.UPLOAD_CTC,
    `/api/v1/bpls/administrator/transaction_histories/permits/${id}/attach_cedula`,
    payload,
    callback
  );

// payment posting:
export const manualPaymentPosting = (id, payload, callback) =>
  req.create(
    c.MANUAL_PAYMENT_POSTING,
    `/api/v1/administrators/transaction_histories/${id}/check_payment_posting`,
    payload,
    callback,
    (res) => {
      const { message } = res.res;
      alert.success(message || 'Successfully Posted !');
      if (callback) callback();
    }
  );

export const getBillingList = (id, payload, callback) =>
  req.list(
    c.GET_BILLING_LIST,
    `/api/v1/bpls/administrator/transaction_histories/permits/${id}/billing_logs`,
    payload,
    ({ res }) => {
      const { data } = res;
      if (callback) callback({ data });
    }
  );

export const updateBilling = (id, payload, callback) =>
  req.create(
    c.UPDATE_BILLING,
    `/api/v1/bpls/administrator/transaction_histories/permits/${id}/regenerate_billing`,
    payload,
    callback
  );

export const updateOrDate = (id, payload, callback) =>
  req.create(
    c.UPDATE_OR_DATE,
    `/api/v1/administrators/transaction_histories/${id}/update_paid_date`,
    payload,
    callback
  );

export const paymentPosting = (id, payload, callback) =>
  req.create(
    c.PAYMENT_POSTING,
    `/api/v1/administrators/transaction_histories/${id}/manual_payment_posting`,
    payload,
    callback
  );
export const updateBusinessState = (id, payload, callback) =>
  req.create(
    c.UPDATE_BUSINESS_STATE,
    `/api/v1/bpls/administrator/transaction_histories/permits/${id}/update_business_state`,
    payload,
    callback
  );

export const addApprovalNote = (id, payload, callback) =>
  req.update(
    c.ADD_APPROVAL_NOTE,
    `/api/v1/bpls/administrator/transaction_histories/permits/${id}/approval_notes`,
    payload,
    callback
  );

export const toggleReassessmentQuarterly = (id, action, payload, callback) =>
  req.create(
    c.TOGGLE_REASSESSMENT_QUARTERLY,
    `api/v1/bpls/administrator/transaction_histories/${id}/reassess/${action}`,
    payload,
    callback
  );

export const reassessApplication = (id, payload, callback) =>
  req.update(
    c.REASSESSMENT_QUARTERLY,
    `api/v1/bpls/administrator/transaction_histories/${id}/reassess`,
    payload,
    callback
  );

export const getLatestPaid = (businessId, callback) =>
  req.item(
    c.GET_LATEST_PAID,
    `/api/v1/bpls/administrator/businesses/${businessId}/applications/latest_paid`,
    ({ res }) => {
      const { data } = res;
      if (callback) callback({ data });
    }
  );
